export default { xs: 0, sm: 800, md: 1024, lg: 1300, xl: 1800 };
